// regular page movement without scroll

// import React from 'react';
// import ReactDOM from 'react-dom';
// import App from './App';
// import { BrowserRouter } from 'react-router-dom';

//  ReactDOM.render(
//    <React.StrictMode>
//     <BrowserRouter>
//      <App />
//     </BrowserRouter> 
//    </React.StrictMode>,
//    document.getElementById('root')
//  );

// -------------------------------------

//code for scrolling
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
//import { BrowserRouter as Router } from 'react-router-dom';
{/* <Router>
</Router> */}

ReactDOM.render(
  <React.StrictMode>
  
    <App />
  
  </React.StrictMode>,
  document.getElementById('root')
);